import React, { useEffect, useState } from 'react';
import {
    postRebatesApi,
    updateRebatesApi,
    deleteRebatesApi,
    postAprobarRebatesApi
} from '../../../../api/axios'
import { formatCurrencyToNumber } from '../../../../helper/publicacionHelper';
import { formatoDecimal } from '../../../../utilities/formatoNumeros';
import { idEstadoRebate } from '../../../../helper/rebateHelper';
import MiniSpinner from "../../../General/MiniSpinner";
import "../../../Rebates/Styles/Rebates.css";
import { toast } from 'react-toastify';

function Rebate({ publicacion, userType, rebate, idUsuario, updateDataRebate }) {
    const DEFAULT_REBATE = {
        aCargoMegatone: 0,
        aCargoSeller: 0,
        fechaInicio: "",
        fechaVencimiento: "",
        idAdminAprueba: 0,
        idCategoryGeneraRebate: 0,
        idEstadoRebate: 0,
        idPublicacion: 0,
        idSellerAprueba: 0,
        porcentajesRebate: {
            porcentajeMegatone: 0,
            porcentajeSeller: 0,
            porcentajeTotalDescuento: 0,
        },
        precioFinal: 0,
        precioInicial: 0,
        unidades: 0,
    };
    const [isLoading, setIsLoading] = useState(false);
    const [tieneRebate, setTieneRebate] = useState(publicacion.tieneRebate);
    const [rebateState, setRebate] = useState(DEFAULT_REBATE);

    useEffect(() => {
        const r = rebate?.rebate ?? rebate;
        const porcentajes = rebate?.porcentajesRebate ?? {
            porcentajeMegatone: 0,
            porcentajeSeller: 0,
            porcentajeTotalDescuento: 0
        };

        if (publicacion.tieneRebate && r) {
            setRebate(prevState => ({
                ...prevState,
                idPublicacion: r.idPublicacion,
                precioInicial: parseFloat(r.precioInicial),
                precioFinal: r.precioFinal,
                aCargoMegatone: parseFloat(r.aCargoMegatone ?? 0),
                aCargoSeller: parseFloat(r.aCargoSeller ?? 0),
                idCategoryGeneraRebate: r.idCategoryGeneraRebate,
                fechaInicio: r.fechaInicio ? r.fechaInicio.slice(0, 10) : "",
                fechaVencimiento: r.fechaVencimiento ? r.fechaVencimiento.slice(0, 10) : "",
                unidades: r.unidades,
                idAdminAprueba: r.idAdminAprueba,
                idSellerAprueba: r.idSellerAprueba,
                porcentajesRebate: {
                    porcentajeMegatone: porcentajes.porcentajeMegatone ?? 0,
                    porcentajeSeller: porcentajes.porcentajeSeller ?? 0,
                    porcentajeTotalDescuento: porcentajes.porcentajeTotalDescuento ?? 0,
                },
                idEstadoRebate: rebate?.idEstadoRebate,
                idRebate: r.id
            }));
        } else {
            const precio = publicacion.precioPromocional === "0,00" || isNaN(parseFloat(publicacion.precioPromocional))
                ? publicacion.precioLista
                : publicacion.precioPromocional;

            setRebate(prevState => ({
                ...prevState,
                precioFinal: precio
            }));
        }
    }, [publicacion.tieneRebate, rebate]);




    const myChangeHandler = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setRebate(prevState => ({ ...prevState, [name]: value }));
    };

    const myChangeAmount = async (e) => {
        e.preventDefault();

        const { name, value } = e.target;
        let valueParsed = value ? parseFloat(value) : 0;
        e.target.value = valueParsed;

        const precioInicial =
            publicacion.precioPromocional === "0,00" || isNaN(parseFloat(publicacion.precioPromocional))
                ? publicacion.precioLista
                : publicacion.precioPromocional;

        const inicial = Number((parseFloat(precioInicial.toString().replace(/\./g, '').replace(',', '.'))).toFixed(2)) || 0;

        let precioFinal = 0;
        let porcentajeTotal = 0;

        if (name === "aCargoSeller") {
            const sale = parseFloat(rebateState.aCargoMegatone) + valueParsed;
            precioFinal = Number((inicial - sale).toFixed(2));
            const porcentaje = (valueParsed * 100) / inicial;
            porcentajeTotal = porcentaje + parseFloat(rebateState.porcentajesRebate.porcentajeMegatone);

            setRebate(prev => ({
                ...prev,
                aCargoSeller: valueParsed,
                precioFinal: precioFinal,
                porcentajesRebate: {
                    ...prev.porcentajesRebate,
                    porcentajeSeller: porcentaje.toFixed(2),
                    porcentajeTotalDescuento: porcentajeTotal.toFixed(2)
                }
            }));
        }

        if (name === "aCargoMegatone") {
            const sale = parseFloat(rebateState.aCargoSeller) + valueParsed;
            precioFinal = Number((inicial - sale).toFixed(2));
            const porcentaje = (valueParsed * 100) / inicial;
            porcentajeTotal = porcentaje + parseFloat(rebateState.porcentajesRebate.porcentajeSeller);

            setRebate(prev => ({
                ...prev,
                aCargoMegatone: valueParsed,
                precioFinal: precioFinal,
                porcentajesRebate: {
                    ...prev.porcentajesRebate,
                    porcentajeMegatone: porcentaje.toFixed(2),
                    porcentajeTotalDescuento: porcentajeTotal.toFixed(2)
                }
            }));
        }
    };

    const onDelete = (event) => {
        event.preventDefault();
        const req = deleteRebatesApi(rebate.rebate.id);
        req.then(response => {
            toast.success("Rebate eliminado");
            setTieneRebate(false);
            setRebate(prevState => ({
                ...DEFAULT_REBATE,
                precioFinal: publicacion.tieneRebate ? 0 : publicacion.precioLista,
                porcentajesRebate: { ...prevState.porcentajesRebate }
            }));
        }).catch(err => {
            err.response?.data?.errores?.forEach(error => toast.error(error)) ||
                toast.error("No pudo eliminarse");
        });
    };

    const onChangeState = (event) => {
        event.preventDefault();
        setIsLoading(true);


        let request = {
            idRebate: rebate.rebate.id,
            idUsuario: idUsuario,
        };

        switch (event.target.name) {
            case "aprove":
                request.idEstado = idEstadoRebate.aprobado;
                break;
            case "sellerAprove":
                request.idEstado = idEstadoRebate.aprobadoPorSeller;
                break;
            case "decline":
                request.idEstado = idEstadoRebate.rechazado;
                break;
            default:
                break;
        }

        const req = postAprobarRebatesApi(request);
        req.then(response => {
            if (request.idEstado === idEstadoRebate.aprobado || request.idEstado === idEstadoRebate.aprobadoPorSeller) {
                toast.success("Rebate aprobado");
                setRebate(prevState => ({ ...prevState, idEstadoRebate: request.idEstado }));
            } else {
                toast.success("Rebate desaprobado");
                setTieneRebate(false);
                setRebate(prevState => ({
                    ...DEFAULT_REBATE,
                    precioFinal: publicacion.tieneRebate ? 0 : publicacion.precioLista,
                    porcentajesRebate: { ...prevState.porcentajesRebate }
                }));
            }
        }).catch(err => {
            (err.response?.data?.errores)
                ? err.response.data.errores.forEach(error => toast.warn(error))
                : toast.error("No pudo modificarse el estado");
        }).finally(() => {
            setIsLoading(false);
        });
    };

    const onSubmit = (event) => {
        event.preventDefault();

        const { precioFinal, aCargoMegatone, aCargoSeller, unidades, fechaInicio, fechaVencimiento, precioInicial } = rebateState;
        if (formatCurrencyToNumber(precioFinal) < 0) {
            toast.error("El precio final no puede ser negativo");
            return;
        }
        if (formatCurrencyToNumber(aCargoMegatone) <= 0 && formatCurrencyToNumber(aCargoSeller) <= 0) {
            toast.error("Al menos uno de los valores debe ser mayor a cero (Megatone o Seller)");
            return;
        }
        //if (formatCurrencyToNumber(aCargoMegatone) <= 0) {
        //    toast.error("El precio a cargo de megatone debe ser mayor a cero");

        //}
        //if (formatCurrencyToNumber(aCargoSeller) <= 0) {
        //    toast.error("El precio a cargo del seller debe ser mayor a cero");

        //}
        if (formatCurrencyToNumber(unidades) < 0) {
            toast.error("La cantidad de unidades no puede ser negativa");
            return;
        }

        // --- NUEVAS VALIDACIONES ---
        const unidadesNum = unidades ? formatCurrencyToNumber(unidades) : 0;

        // 1) Si ambas fechas tienen valor: validar orden y que NO haya unidades
        if (fechaInicio && fechaVencimiento) {
            if (new Date(fechaInicio) >= new Date(fechaVencimiento)) {
                toast.error("La fecha de inicio debe ser menor que la fecha de vencimiento");
                return;
            }
            if (unidades && unidadesNum > 0) {
                toast.error("Si se ingresan fechas, las unidades deben quedar vacías");
                return;
            }
        }

        // 2) Si NO hay ninguna fecha: deben existir unidades > 0
        if (!fechaInicio && !fechaVencimiento) {
            if (!unidades || unidadesNum <= 0) {
                toast.error("Debe ingresar ambas fechas o bien las unidades (> 0)");
                return;
            }
        }

        // 3) Caso restante: hay una sola fecha (con o sin unidades) -> inválido
        if ((fechaInicio && !fechaVencimiento) || (!fechaInicio && fechaVencimiento)) {
            if (unidades && unidadesNum > 0) {
                toast.error("Si se ingresan unidades, las fechas deben estar vacías");
                return;
            } else {
                toast.error("Debe ingresar ambas fechas");
                return;
            }
        }

        ///// agregue estas lineas
        let rebateRequest = {
            idPublicacion: publicacion.idPublicacion,
            precioFinal: precioFinal,
            aCargoMegatone: aCargoMegatone ?? null,
            aCargoSeller: aCargoSeller ?? null,
            idCategoryGeneraRebate: idUsuario,
            precioInicial: formatCurrencyToNumber(precioInicial),
            // idRebate: rebate?.rebate?.id ?? rebate?.id ?? null 
        };

        // --- fechas y unidades ---
        if (fechaInicio && fechaVencimiento) {
            // Caso con fechas
            rebateRequest.fechaInicio = fechaInicio;
            rebateRequest.fechaVencimiento = fechaVencimiento;
            rebateRequest.unidades = null; // forzamos 0 o null ???????
        } else if (unidades && parseInt(unidades) > 0) {
            //  Caso con unidades
            rebateRequest.unidades = parseInt(unidades);
            rebateRequest.fechaInicio = null;      //// forzamos null o string ????????
            rebateRequest.fechaVencimiento = null;  //// forzamos null o string ????????
        }


        if (event.target.name === "send") {
            rebateRequest.precioInicial = formatCurrencyToNumber(publicacion.precioPromocional);

            if (rebateRequest.precioInicial == null || rebateRequest.precioInicial === 0) {
                rebateRequest.precioInicial = formatCurrencyToNumber(publicacion.precioLista);
            }
            const req = postRebatesApi(rebateRequest);
            req.then(response => {
                toast.success("Rebate enviado");
                updateDataRebate(publicacion.idPublicacion);
                let rebate = updateDataRebate(publicacion.idPublicacion);
                setRebate(prevState => ({ ...prevState, idEstadoRebate: 1 }));
                setTieneRebate(true);
                return;
            })
                .catch(err => {
                    if (err.response?.data?.errors) {
                        err.response.data.errors.forEach(error => {
                            toast.error(error.message);
                        });
                    } else {
                        toast.error("No pudo crearse");
                    }
                })
        } else {
            rebateRequest.idRebate = rebateState.idRebate;
            const req = updateRebatesApi(rebateRequest);
            req.then(response => {
                toast.success("Rebate modificado");
                updateDataRebate(publicacion.idPublicacion);
                let rebate = updateDataRebate(publicacion.idPublicacion);
                setRebate(prevState => ({ ...prevState, rebate }));
                return;
            }).catch(err => {
                const errores = err?.response?.data?.errores;
                if (errores && Array.isArray(errores)) {
                    errores.forEach(error => toast.error(error.message)); // <<< usar solo el mensaje
                } else {
                    toast.error("Complete los campos requeridos");
                }
            });



        }
    }

    let precioFinalFormatted = formatoDecimal(rebateState.precioFinal);
    const isFechaBloqueada = Boolean(rebate?.rebate?.id || rebate?.id);

    return (
        <div
            className={`col-12 col-md-7 tab-pane p-20 active card-rebate 
                ${userType.isAdminMod && rebate.idAdminAprueba === 0
                    ? "top-color-rojo"
                    : publicacion.tieneRebate
                        ? "top-color-verde"
                        : "card w-auto"
                }`
            }
            role="tabpanel"
            hidden={
                (userType.isSellerAdmin || userType.isSeller) && !tieneRebate ||
                userType.isSellerAdmin &&
                (rebate.idEstadoRebate === idEstadoRebate.aprobadoPorCategory ||
                    rebate.idEstadoRebate === idEstadoRebate.rechazado)
            }
        >
            {publicacion.tieneRebate
                && userType.isAdminMod
                && (rebateState.idEstadoRebate === idEstadoRebate.aprobado
                    || rebateState.idCategoryGeneraRebate !== 0)
                ? <h4 className="text-themecolor color-verde-megatone">Rebate Enviado</h4>
                : <h4 className="text-themecolor color-rojo-megatone">Nuevo Rebate</h4>
            }

            <div
                className="container"
                hidden={!userType.isSellerAdmin || !tieneRebate || rebateState.idEstadoRebate === idEstadoRebate.aprobadoPorCategory}
            >
                <p hidden={!rebateState.fechaInicio} className="text-secondary fs-8">
                    {rebateState.fechaInicio} al {rebateState.fechaVencimiento}
                </p>

                <div className="d-flex flex-row align-items-center justify-content-between animated fadeIn">

                    <div className="col-auto">
                        <h2 className="text-themecolor color-rojo-megatone">{rebateState.porcentajesRebate.porcentajeTotalDescuento} % OFF</h2>
                    </div>

                    <div className="col-auto border-start mx-2 ps-1">
                        <div className="d-flex flex-row rebate-text">
                            <h6 className="text-themecolor color-rojo-megatone">{rebateState.porcentajesRebate.porcentajeMegatone} % </h6>
                            <p className="text-secondary fs-6 ms-1">${rebateState.aCargoMegatone} a cargo del MegaMarket</p>
                        </div>
                        <div className="d-flex flex-row">
                            <h6 className="text-themecolor color-rojo-megatone">{rebateState.porcentajesRebate.porcentajeSeller} % </h6>
                            <p className="text-secondary fs-6 ms-1">${rebateState.aCargoSeller} a cargo del Seller</p>
                        </div>
                    </div>

                    <div className="col-auto d-flex flex-column justify-content-end">
                        {rebateState.idEstadoRebate !== idEstadoRebate.aprobadoPorSeller &&
                            <>
                                {isLoading ? <MiniSpinner /> :
                                    <>
                                        <button
                                            name="sellerAprove"
                                            onClick={onChangeState}
                                            className="btn m-r-10 btn-sm waves-light mb-md-3 btn-green"
                                        >
                                            Aceptar Oferta
                                        </button>
                                        <button
                                            name="decline"
                                            onClick={onChangeState}
                                            className="btn m-r-10 btn-sm background-rojo-megatone waves-light mb-md-3"
                                        >
                                            Rechazar Oferta
                                        </button>

                                    </>
                                }
                            </>
                        }
                    </div>
                </div>

                <div className="row justify-content-right animated fadeIn">
                    <div className="col-auto">
                        <div className="d-flex flex-row">
                            <h6 className="text-themecolor color-rojo-megatone">Precio Final:</h6>
                            <p className="text-secondary mx-2">${rebateState.precioFinal}</p>
                        </div>
                    </div>
                    <div className="col-auto">
                        <div className="d-flex flex-row">
                            <h6 className="text-themecolor text-secondary">Unidades:</h6>
                            <p className="text-secondary mx-2">{rebateState.unidades}</p>
                        </div>
                    </div>
                </div>
            </div>

            {!userType.isSellerAdmin &&
                <div className="form-group">

                    <div className="row mb-3 flex align-items-end">
                        <div className="col-auto">
                            <label>Precio Final</label>
                            <input
                                type="text"
                                name="precioFinal"
                                className="form-control"
                                value={precioFinalFormatted}
                                disabled
                            />
                        </div>
                        <div className="col-auto">
                            <h6 className="text-themecolor color-rojo-megatone">
                                {rebateState.porcentajesRebate.porcentajeTotalDescuento > 100
                                    ? "Error"
                                    : rebateState.porcentajesRebate.porcentajeTotalDescuento + "%"}
                            </h6>
                        </div>
                    </div>

                    <div className="row mb-3 flex align-items-end">
                        <div className="col-auto">
                            <label>A cargo de Megatone</label>
                            <input
                                type="number"
                                className="form-control"
                                disabled={publicacion.tieneRebate && userType.isSellerAdmin}
                                value={rebateState.aCargoMegatone}
                                onChange={myChangeAmount}
                                name="aCargoMegatone"
                                min="0"
                            />
                        </div>

                        <div className="col-auto">
                            <h6 className="text-themecolor color-rojo-megatone">
                                {rebateState.porcentajesRebate.porcentajeMegatone > 100 ? "Error" : rebateState.porcentajesRebate.porcentajeMegatone + "%"}
                            </h6>
                        </div>

                        <div className="col-auto">
                            <label>A cargo del seller</label>
                            <input
                                type="number"
                                className="form-control"
                                disabled={publicacion.tieneRebate && userType.isSellerAdmin}
                                value={rebateState.aCargoSeller ?? 0}
                                onChange={myChangeAmount}
                                name="aCargoSeller"
                                min="0"
                            />

                        </div>

                        <div className="col-auto align-center">
                            <h6 className="text-themecolor color-rojo-megatone">
                                {rebateState.porcentajesRebate.porcentajeSeller > 100 ? "Error" : rebateState.porcentajesRebate.porcentajeSeller + "%"}
                            </h6>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-auto">
                            <label className="label-oscura">Fecha Inicio</label>
                            <input
                                type="date"
                                name="fechaInicio"
                                className={`form-control ${tieneRebate ? 'input-disabled' : ''}`}
                                onChange={myChangeHandler}
                                value={rebateState.fechaInicio}
                                disabled={tieneRebate}
                            />
                        </div>
                        <div className="col-auto">
                            <label className="label-oscura ml-2">Fecha Vencimiento</label>
                            <input
                                type="date"
                                name="fechaVencimiento"
                                className={`form-control ${tieneRebate ? 'input-disabled' : ''}`}
                                onChange={myChangeHandler}
                                value={rebateState.fechaVencimiento}
                                disabled={tieneRebate}
                            />
                        </div>
                        <div className="col-auto mb-3">
                            <label>Unidades</label>
                            <input
                                type="number"
                                id="unidades"
                                className="form-control"
                                disabled={tieneRebate && userType.isSellerAdmin}
                                value={rebateState.unidades}
                                onChange={myChangeHandler}
                                name="unidades"
                                min="0"
                            />
                        </div>
                    </div>
                    {(userType.isCategory || userType.isAdminMod) && !tieneRebate ?
                        <div>
                            <button
                                onClick={onSubmit}
                                name="send"
                                className="btn m-r-10 btn-sm background-rojo-megatone waves-light mb-md-5"
                            >
                                Enviar al administrador
                            </button>
                        </div> :

                        (userType.isSellerAdmin && rebateState.idEstadoRebate === idEstadoRebate.aprobado) || (userType.isAdminMod && rebateState.idEstadoRebate === idEstadoRebate.aprobadoPorCategory) ?
                            <div>
                                <button
                                    onClick={onChangeState}
                                    name="aprove"
                                    className="btn m-r-10 btn-sm background-rojo-megatone  waves-light mb-md-5"
                                >
                                    Aprobar
                                </button>
                                <button
                                    onClick={onChangeState}
                                    name="decline"
                                    className="btn m-r-10 btn-sm btn-grey waves-light mb-md-5">
                                    Rechazar
                                </button>
                                <button
                                    onClick={onSubmit}
                                    hidden={(userType.isCategory && rebate.idEstadoRebate === idEstadoRebate.aprobado) || (userType.isAdminMod && rebate.idEstadoRebate === idEstadoRebate.aprobadoPorSeller)}
                                    type="submit"
                                    name="update"
                                    className="btn m-r-10 btn-sm btn-light waves-light mb-md-5"
                                >
                                    Modificar
                                </button>
                            </div>
                            :
                            <div>
                                <button
                                    type="submit"
                                    onClick={onDelete}
                                    className="btn m-r-10 btn-sm btn-grey waves-light mb-md-5"
                                >
                                    Eliminar
                                </button>
                                <button
                                    type="submit"
                                    name="update"
                                    onClick={onSubmit}
                                    disabled={rebateState.idEstadoRebate === idEstadoRebate.aprobadoPorSeller}
                                    className="btn m-r-10 btn-sm btn-light waves-light mb-md-5"
                                >
                                    Modificar
                                </button>
                            </div>
                    }

                    {userType.isCategory ?
                        <p hidden={!tieneRebate} className="text-secondary fs-10">Enviado rebate al administrador</p> :
                        <p hidden={rebateState.idAdminAprueba === 0} className="text-secondary fs-10">Enviado rebate al seller</p>
                    }
                </div>
            }
        </div>
    );
}

export default Rebate;